import { useEffect, useState, useRef } from 'react';
import { get, post, del, put } from '../../helpers/api_helper';
import { Row, Col, Card, CardBody, CardTitle, Button, Modal, ModalBody, ModalHeader, ModalFooter, Table, Input } from "reactstrap"
import Select from "react-select";
import toastr from 'toastr';
import { NumberInput } from "../../utils";
import { getAllAddress } from "../../helpers/address";

import Breadcrumbs from "../../components/Common/Breadcrumb"
import './index.scss';

const HCM_PROVINCE_ID = 79;
const isHCM = (e) => e.provinceId === HCM_PROVINCE_ID || /h[oồ] ch[ií] minh/i.test(e?.Province?.name || '');
const compareVi = (a = '', b = '') => a.localeCompare(b, 'vi', { sensitivity: 'base', numeric: true });
// Bỏ dấu tiếng Việt để tìm kiếm không phân biệt dấu
const normalize = (str = '') => str
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/đ/g, 'd')
  .replace(/Đ/g, 'D')
  .toLowerCase()
  .trim();

const sortDelivery = (a, b) => {
  // TP. Hồ Chí Minh luôn lên đầu
  const hcm = (isHCM(b) ? 1 : 0) - (isHCM(a) ? 1 : 0);
  if (hcm !== 0) return hcm;
  // Thành phố A -> Z
  const province = compareVi(a?.Province?.name, b?.Province?.name);
  if (province !== 0) return province;
  // Dòng áp dụng cho cả thành phố (không có phường) nằm trước
  const noWard = (a?.Ward?.name ? 1 : 0) - (b?.Ward?.name ? 1 : 0);
  if (noWard !== 0) return noWard;
  // Phường A -> Z
  return compareVi(a?.Ward?.name, b?.Ward?.name);
};

const COST_KEYS = [
  'estimateDeliveryCostNormal',
  'estimateDeliveryCostFaster',
  'estimateDeliveryOverCostNormal',
  'estimateDeliveryOverCostFaster',
];

// react-select nằm trong vùng scroll nên render menu ra body để không bị che
const selectPortalProps = {
  menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
  styles: { menuPortal: (base) => ({ ...base, zIndex: 9999 }) },
};

const Category = props => {
  const [list, setList] = useState([]);
  const [allAddress, setAllAddress] = useState([]);
  const [provinceSelected, setProvinceSelected] = useState(null);
  const [wardSearch, setWardSearch] = useState('');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    get(`/delivery/list`)
      .then((data) => {
        setList(data.sort(sortDelivery))
      })
    getAllAddress().then(setAllAddress);
  }, [])

  const onChange = (deli, key, value) => {
    setList(list.map((e) => (e.id === deli.id ? { ...e, [key]: value } : e)));
  }

  // Thêm dòng giá riêng cho phường, giá mặc định lấy theo dòng chung của tỉnh
  const onAddWard = (ward) => {
    const province = allAddress.find((p) => p.id === provinceSelected);
    const provinceRow = list.find((e) => e.provinceId === provinceSelected && !e.wardId);
    setList([...list, {
      id: `new-${ward.id}`,
      provinceId: province.id,
      wardId: ward.id,
      Province: { id: province.id, name: province.name },
      Ward: { id: ward.id, name: ward.name, provinceId: province.id },
      ...Object.fromEntries(COST_KEYS.map((k) => [k, provinceRow ? provinceRow[k] : 0])),
      rangeFreeShip: provinceRow ? provinceRow.rangeFreeShip : null,
    }].sort(sortDelivery));
  }

  // Chỉ xoá được dòng phường, dòng tỉnh/thành phố luôn giữ lại
  const onRemoveWard = (deli) => {
    if (!deli.wardId) return;
    setList(list.filter((e) => e.id !== deli.id));
  }

  const onSave = () => {
    setLoading(true);
    put(`/delivery/update`, {
      items: list.map((e) => {
        const {
          provinceId,
          wardId,
          estimateDeliveryCostNormal,
          estimateDeliveryCostFaster,
          estimateDeliveryOverCostFaster,
          estimateDeliveryOverCostNormal,
          rangeFreeShip,
        } = e;
        return {
          provinceId,
          wardId,
          estimateDeliveryCostNormal,
          estimateDeliveryCostFaster,
          estimateDeliveryOverCostFaster,
          estimateDeliveryOverCostNormal,
          ...(rangeFreeShip !== null ? { rangeFreeShip: +rangeFreeShip }: {}),
        }
      })
    })
      .then(() => {
        toastr.success('Cập nhật thành công thành công');
      })
      .catch((err) => {
        toastr.error(err.error);
      })
      .finally(() => {
        setLoading(false);
      })
  }

  const listProvinces = () => {
    const obj = {};
    list.forEach((e) => {
      obj[`p-${e.provinceId}`] = {
        label: e.Province.name,
        value: e.Province.id
      }
    });
    return Object.values(obj);
  }

  // Phường của tỉnh đang chọn mà chưa có dòng giá riêng
  const listWardsCanAdd = () => {
    const province = allAddress.find((p) => p.id === provinceSelected);
    if (!province) return [];
    const hasRow = new Set(list.filter((e) => e.wardId).map((e) => +e.wardId));
    return province.Wards
      .filter((ward) => !hasRow.has(ward.id))
      .map((ward) => ({ label: ward.name, value: ward.id, ward }));
  }

  const filteredList = () => {
    const keyword = normalize(wardSearch);
    return list.filter((e) => {
      if (provinceSelected && e.provinceId !== provinceSelected) return false;
      if (keyword && !normalize(e?.Ward?.name).includes(keyword)) return false;
      return true;
    });
  }

  return (
    <>
      <div className="page-content page-pricedelivery">
        <Breadcrumbs title="Danh mục" breadcrumbItem="Danh sách danh mục" />
        <Row>
          <Col md={12} xs={12}>
            <Card className="list-category">
              <CardBody>
                <div className="table-responsive">
                  <Table>
                    <thead>
                      <tr>
                        <th width="20%">
                          <Select
                            placeholder="Lọc theo thành phố"
                            options={listProvinces()}
                            isClearable={true}
                            onChange={(value) => {
                              setProvinceSelected(value?.value);
                            }}
                            {...selectPortalProps}
                          />
                          <Input
                            className="mt-2"
                            type="search"
                            placeholder="Tìm tên phường"
                            value={wardSearch}
                            onChange={(e) => setWardSearch(e.target.value)}
                          />
                          <div className="mt-2">
                            <Select
                              placeholder={provinceSelected ? "+ Thêm phường" : "Chọn thành phố để thêm phường"}
                              options={listWardsCanAdd()}
                              isDisabled={!provinceSelected}
                              value={null}
                              onChange={(option) => option && onAddWard(option.ward)}
                              noOptionsMessage={() => "Không còn phường để thêm"}
                              {...selectPortalProps}
                            />
                          </div>
                        </th>
                        <th width="25%">
                          VC Chậm
                        </th>
                        <th width="25%">
                          VC Nhanh
                        </th>
                        <th width="20%">
                          Ngưỡng miễn ship
                        </th>
                        <th width="10%">
                          <Button disabled={loading} className="btn-success" onClick={() => onSave()}><i className="fa fa-save"></i> Lưu tất cả</Button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredList().map((deli) =>
                        <tr key={deli.id}>
                          <td>
                            {deli?.Ward?.name ? <>{deli?.Ward?.name}<br /></> : ''}
                            {deli.Province.name}
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <span style={{ width: '90px' }}>{"< 1 ký: "} </span>
                              <NumberInput
                                value={deli.estimateDeliveryCostNormal}
                                onChange={(e) => onChange(deli, 'estimateDeliveryCostNormal', e.value)}
                                customInput={Input}
                                suffix={" đ"}
                                decimalScale={0}
                              />
                            </div>
                            <div className="d-flex align-items-center mt-1">
                              <span style={{ width: '90px' }}>{"1 ký quá: "}</span>
                              <NumberInput
                                onChange={(e) => onChange(deli, 'estimateDeliveryOverCostNormal', e.value)}
                                customInput={Input}
                                suffix={" đ"}
                                value={deli.estimateDeliveryOverCostNormal}
                                decimalScale={0}
                              />
                            </div>
                          </td>
                          <td className="">
                            <div className="d-flex align-items-center">
                              <span style={{ width: '90px' }}>{"< 1 ký: "} </span>
                              <NumberInput
                                value={deli.estimateDeliveryCostFaster}
                                onChange={(e) => onChange(deli, 'estimateDeliveryCostFaster', e.value)}
                                customInput={Input}
                                suffix={" đ"}
                                decimalScale={0}
                              />
                            </div>
                            <div className="d-flex align-items-center mt-1">
                              <span style={{ width: '90px' }}>{"1 ký quá: "}</span>
                              <NumberInput
                                value={deli.estimateDeliveryOverCostFaster}
                                onChange={(e) => onChange(deli, 'estimateDeliveryOverCostFaster', e.value)}
                                customInput={Input}
                                suffix={" đ"}
                                decimalScale={0}
                              />
                            </div>
                          </td>
                          <td>
                            <NumberInput
                              placeholder='Ngưỡng miễn phí vận chuyển'
                              value={deli.rangeFreeShip}
                              onChange={(e) => onChange(deli, 'rangeFreeShip', e.value)}
                              customInput={Input}
                              suffix={" đ"}
                              decimalScale={0}
                            />
                          </td>
                          <td>
                            {deli.wardId ? (
                              <Button color="danger" outline size="sm" title="Xoá phường" onClick={() => onRemoveWard(deli)}>
                                <i className="fa fa-trash"></i>
                              </Button>
                            ) : ''}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default Category
